// src/styles/appleClasses.ts

const fieldBase =
  "w-full rounded-xl text-[13px] font-normal text-gray-700 ios-no-zoom " +
  "border border-gray-200 bg-white transition " +
  "focus:outline-none focus:ring-2 focus:ring-appleblue/20 focus:border-appleblue/50";

const fieldDisabled = "bg-gray-50 text-gray-400 cursor-not-allowed";

const inputChrome = "h-10 px-4";
const textareaChrome = "px-4 py-2";

export const A = {
  body: "text-[13px] font-normal text-gray-700",
  label: "text-xs text-gray-500",
  title: "text-[15px] font-semibold text-gray-700",
  num: "tabular-nums",

  card: "bg-white border border-gray-200 rounded-2xl shadow-sm",
  panel: "bg-white border border-gray-200 rounded-2xl shadow-sm",
  modal: "bg-white border border-gray-200 rounded-2xl shadow-sm",

  fieldBase,
  fieldDisabled,

  // keep backward compatibility
  inputBase: `${fieldBase} ${inputChrome}`,
  input: `${fieldBase} ${inputChrome}`,

  // new optional composition tokens
  inputChrome,
  textareaChrome,

  muted: "text-xs text-gray-500",

  iconBtn: "h-10 w-10 rounded-xl",

  pillBase:
    "inline-flex items-center rounded-full px-2.5 py-0.5 " +
    "text-xs font-medium leading-none ring-1",

  btnBase:
    "inline-flex items-center justify-center leading-none select-none " +
    "h-10 px-4 rounded-xl " +
    "text-[13px] font-medium " +
    "transition duration-150 ease-in-out " +
    "focus:outline-none focus:ring-2 focus:ring-appleblueD " +
    "disabled:opacity-50 disabled:cursor-not-allowed " +
    "active:scale-95 disabled:active:scale-100",

  btnPrimary:
    "bg-appleblue text-white " +
    "hover:bg-appleblueD " +
    "active:bg-appleblueDD",

  btnSecondary:
    "bg-white border border-gray-200 text-gray-700 " +
    "hover:bg-gray-50 hover:border-gray-300 " +
    "active:bg-gray-100 active:border-gray-300 " +
    "focus:border-appleblue",

  btnOutline:
    "bg-white border border-appleblue text-appleblue " +
    "hover:bg-appleblue/10 active:bg-appleblue/20 " +
    "focus:outline-none focus:ring-2 focus:ring-appleblueD transition",

  btnDanger:
    "bg-red-600 text-white border border-transparent " +
    "hover:bg-red-700 active:bg-red-800 " +
    "focus:outline-none focus:ring-2 focus:ring-red-300 transition",

  btnTertiary:
    "bg-transparent border border-transparent text-appleblue " +
    "hover:bg-gray-100 active:bg-gray-200 " +
    "disabled:text-gray-300 disabled:hover:bg-transparent",
} as const;

// Canonical pill tones
export const pillTone = {
  brand: "bg-appleblue/10 text-appleblue ring-appleblue/20",
  success: "bg-green-50 text-green-700 ring-green-100",
  warning: "bg-amber-50 text-amber-700 ring-amber-100",
  neutral: "bg-gray-50 text-gray-600 ring-gray-100",
  info: "bg-sky-50 text-sky-700 ring-sky-100",
} as const;

export type PillTone = keyof typeof pillTone;

export function pillClass(tone: PillTone = "neutral") {
  return `${A.pillBase} ${pillTone[tone]}`;
}